import { DataListItem } from '@brighte/form-components';
import { IdentificationType } from '@brighte/validation';
import { useApplicationData } from '@provider';
import { IDENTIFICATION, LABELS, formatAddress } from '@utils';

function useIdentificationSummary(): Array<{ title: string; items: DataListItem[] | [] }> | [] {
  const identification = useApplicationData('Identification');

  if (!identification) return [];
  const {
    identification: { type, passport, drivingLicense, medicare, photoId },
    address,
    dateOfBirth,
  } = identification.applicant;

  const { DATE_OF_BIRTH, HOME_ADDRESS } = LABELS;

  let identificationTitle = '';
  const identificationType = (
    IDENTIFICATION.IDENTIFICATION_OPTIONS.find(option => option.value === type)?.label ?? ''
  ).toUpperCase();

  switch (type) {
    case IdentificationType.PASSPORT:
      identificationTitle = `${identificationType} ${passport?.number}`;
      break;
    case IdentificationType.DRIVING_LICENSE:
      identificationTitle = `${drivingLicense?.state} ${identificationType} ${drivingLicense?.number}`;
      break;
    case IdentificationType.MEDICARE:
      identificationTitle = `${medicare?.color.toLocaleUpperCase()} ${identificationType} ${medicare?.number}`;
      break;
    case IdentificationType.PHOTO_ID:
      identificationTitle = `${photoId?.state} ${identificationType} ${photoId?.number}`;
      break;
    default:
      break;
  }

  const identificationSummary = [
    {
      title: identificationTitle,
      items: [
        {
          label: DATE_OF_BIRTH,
          value: dateOfBirth instanceof Date ? dateOfBirth.toDateString() : dateOfBirth,
        },
        {
          label: HOME_ADDRESS,
          value: address ? formatAddress(address) : '',
        },
      ],
    },
  ];

  return identificationSummary;
}

export { useIdentificationSummary };
